module.exports = __webpack_public_path__ + "img/logo.f2ea740e.png";